export class Poliza {
constructor(
    public row: string, 
    public id: string, 
    public idAseguradora: string, 
    public aseguradora: string,
    public precio: string,
    public nombreMoneda: string,
    public conversionMoneda:string,
    )    
{}
}



// WEBPACK FOOTER //
// ./src/app/obj/poliza.ts